/* eslint-disable no-cond-assign */
/* eslint-disable no-plusplus */
import { Node } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';

import TagComponent from '@/ui/Editor/extensions/Tag/TagComponent';
import { TagAttributes, TagItem, TagOptions } from '@/ui/Editor/extensions/Tag/types';

export const Tag = Node.create<TagOptions>({
	name: 'tag',

	group: 'inline',
	inline: true,
	selectable: false,
	atom: true,

	addOptions() {
		return {
			availableTags: [],
		};
	},

	addAttributes() {
		return {
			tag: {
				default: null,
				parseHTML: (element: HTMLElement) => element.getAttribute('data-tag'),
				renderHTML: (attributes: TagAttributes) => {
					if (!attributes.tag) {
						return {};
					}
					return {
						'data-tag': attributes.tag,
					};
				},
			},
		};
	},

	parseHTML() {
		return [
			{
				tag: 'span[data-tag]',
				getAttrs: (dom) => {
					const tag = dom.getAttribute('data-tag');
					return { tag };
				},
			},
		];
	},

	renderHTML({ node }) {
		const { tag } = node.attrs;
		// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
		return ['span', { 'data-tag': tag }, `${tag}`];
	},

	addNodeView() {
		return ReactNodeViewRenderer(TagComponent);
	},

	addCommands() {
		return {
			setTag:
				(tag) =>
				({ commands }) =>
					commands.insertContent({
						type: this.name,
						attrs: { tag },
					}),
			setAvailableTags: (newTags: TagItem[]) => () => {
				this.options.availableTags = newTags;
				return true;
			},
		};
	},

	onCreate() {
		const { editor } = this;

		editor.on('transaction', ({ editor }) => {
			const { doc } = editor.state;
			const regex = /{{(.*?)}}/g;
			const tagsToInsert: { tag: string; start: number; end: number }[] = [];

			doc.descendants((node, pos) => {
				if (!node.isText) return;

				let match: RegExpExecArray | null;
				while ((match = regex.exec(node.text || '')) !== null) {
					const tag = `{{${match[1]}}}`;
					const start = pos + match.index;
					const end = start + tag.length;

					if (this.options.availableTags.some((item) => item.tag === tag)) {
						tagsToInsert.push({ tag, start, end });
					}
				}
			});

			if (tagsToInsert.length > 0) {
				const { tr } = editor.state;

				for (let i = tagsToInsert.length - 1; i >= 0; i--) {
					const { tag, start, end } = tagsToInsert[i];
					tr.replaceWith(start, end, editor.schema.nodes.tag.create({ tag }));
				}

				editor.view.dispatch(tr);
			}
		});
	},
});
